var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('div',{staticClass:"player embed-responsive-item",attrs:{"id":"player"}})])}]

export { render, staticRenderFns }